import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFF",
      "fill-rule": "evenodd",
      d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0m0 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1m0 2.5a.5.5 0 0 1 .5.5l-.001 2.5H10a.5.5 0 1 1 0 1H7.499L7.5 10a.5.5 0 1 1-1 0l-.001-2.5H4a.5.5 0 0 1 0-1h2.499L6.5 4a.5.5 0 0 1 .5-.5"
    }, null, -1)
  ])))
}
export default { render: render }